module.exports = (__webpack_require__(2023))(994);